"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointSecretRotateIn = void 0;
class EndpointSecretRotateIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointSecretRotateIn.attributeTypeMap;
    }
}
exports.EndpointSecretRotateIn = EndpointSecretRotateIn;
EndpointSecretRotateIn.discriminator = undefined;
EndpointSecretRotateIn.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EndpointSecretRotateIn.js.map